import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { GroupOptionsConfigWrapper } from './styles';

const GroupOptionsConfig = ({ className, onClick, options = [], selectedOption, isDisable }) => {
  return (
    <GroupOptionsConfigWrapper className={classNames(['group-options__main', className])}>
      <div className="group-options__option-list">
        <ul className="list-unstyled">
          {options.map((option) => (
            <li key={option.value} className="mb-3 d-flex align-items-center list-client__text">
              <input
                type="radio"
                onClick={() => onClick(option.value)}
                value={option.value}
                checked={option.value === selectedOption}
                onChange={() => null}
                disabled={isDisable}
              />
              <span className="ml-2">{option.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </GroupOptionsConfigWrapper>
  );
};

GroupOptionsConfig.defaultProps = {
  className: '',
  selectedOption: '',
  isDisable: false,
};

GroupOptionsConfig.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ).isRequired,
  selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDisable: PropTypes.bool,
};

export default GroupOptionsConfig;
